import { styled } from '@mui/material/styles';
import { SvgLogo } from '@noah-labs/fe-shared-ui-assets/images/Logo';

export const AppLogo = styled(SvgLogo)(({ color, theme }) => ({
  color: color || theme.palette.brand.light,
  display: 'block',
  height: '19px',
}));
